module.exports = __webpack_public_path__ + "static/searchcoursebg-d506540b82f2842e0ed1545a2c973e33.svg";